let signedToken = '';

const setToken = tk => signedToken = tk;

const getToken = () => signedToken;

const clearToken = () => signedToken = '';

export default {
    set: setToken,
    get: getToken,
    clear: clearToken,
};
